<template>
  <div class="home">
    <div class="menusArt" style="height:100%">
      <el-row>
        <el-col :span="4" class="mainStyle" >
          <div class="articleContainer">
            <div class="info">
                <div :class="selectIndex==0?'articleName borderStyle':'articleName'" @click="chooseMenus(0)"><span>文章(10)</span></div>
                <div :class="selectIndex==1?'articleName borderStyle':'articleName'" @click="chooseMenus(1)"><span>视频(10)</span></div>
                <div :class="selectIndex==2?'articleName borderStyle':'articleName'" @click="chooseMenus(2)"><span>作品(10)</span></div>
                <div style="margin-bottom:20px;border-bottom: none;" :class="selectIndex==3 ?'articleName borderStyle':'articleName'" @click="chooseMenus(3)"><span>问答(10)</span></div>
            </div>
          </div>
        </el-col>
        
        <el-col :span="20" style="padding:20px 0 0 20px;">
          <div >
             <el-row class="jifen" v-if="selectIndex==0">
                <el-col :span="3" class="jifenGet">TA的的文章</el-col>
                <el-col :span="5" class="getMore">
                  <span>按时间排序</span>
                  <span><img style="vertical-align: middle;margin-left:5px;" src="@/assets/icons/shang.png" /></span>
                </el-col>
              </el-row>
              <el-row class="jifen" v-if="selectIndex==1">
                <el-col :span="3" class="jifenGet">TA的的视频</el-col>
                <el-col :span="5" class="getMore">
                  <span>按时间排序</span>
                  <span><img style="vertical-align: middle;margin-left:5px;" src="@/assets/icons/shang.png" /></span>
                </el-col>
              </el-row>
              <el-row class="jifen" v-if="selectIndex==2">
                <el-col :span="3" class="jifenGet">TA的的作品</el-col>
                <el-col :span="5" class="getMore">
                  <span>按时间排序</span>
                  <span><img style="vertical-align: middle;margin-left:5px;" src="@/assets/icons/shang.png" /></span>
                </el-col>
              </el-row>
              <el-row class="jifen" v-if="selectIndex==3">
                <el-col :span="3" class="jifenGet">TA的的问答</el-col>
                <el-col :span="5" class="getMore">
                  <span>按时间排序</span>
                  <span><img style="vertical-align: middle;margin-left:5px;" src="@/assets/icons/shang.png" /></span>
                </el-col>
              </el-row>
        
            <el-row class="jfCont" >
              <div class="articles" v-if="selectIndex==0">
                <div class="articleContent">
                  <ManagerArticleV v-for="n in 4"/>
                </div>
                <div class="articleContent">
                  <ManagerArticleV v-for="n in 4"/>
                </div>
              </div> 

              <div class="articles" v-if="selectIndex==1">
                <div class="articleContent">
                  <VideoV v-for="n in 4"/>
                </div>
                <div class="articleContent">
                  <VideoV v-for="n in 4"/>
                </div>
              </div> 

              <div class="articles" v-if="selectIndex==2">
                <div class="articleContent">
                  <Works v-for="n in 4"/>
                </div>
                <div class="articleContent">
                  <Works v-for="n in 4"/>
                </div>
              </div> 

              <div class="answerQuestion" v-if="selectIndex==3">
                <div class="answerContent">
                  <AnswerV v-for="n in 3"/>
                </div>
              </div>
              
               
            </el-row>
        </div>



        

         
        </el-col>

        
      </el-row>
    </div>
  </div>
</template>

<script>

// import SubscribeMenus from '@/components/userCenter/SubscribeMenus.vue'
import VideoV from '@/components/userCenter/VideoV.vue'
import ManagerArticleV from '@/components/userCenter/ManagerArticleV.vue'
import Works from '@/components/userCenter/Works.vue'
import QuestionsC from '@/components/userCenter/QuestionsC.vue'
import AnswerV from '@/components/userCenter/AnswerV.vue'

export default {
  name: 'Home',
  components: {
    
    VideoV,
   
    ManagerArticleV,
    Works,
    QuestionsC,
    AnswerV
    // SubscribeMenus
  },
  data() {
    return {
      categaries : [{text:'Maya',value:'1'}],
      selectIndex:0
    }
  },
  computed:{
      // getSelectIndex(){
      //     if(this.$store.state.userCenter.selectIndex){
      //         return this.$store.state.userCenter.selectIndex;
      //     }
      //     return this.selectIndex;
      // }
  },
  methods:{
    chooseMenus(index){
      this.selectIndex = index;
    },
    
    format(percentage) {
        // return percentage === 100 ? '满' : `${percentage}%`;
        return '';
      },
      
  },
}
</script>
<style lang="stylus" scoped>

  .home{
    width 100%;
    height :100%;
    padding-bottom 80px;
    background-color #F3F3F5;
    min-width:1200px;
    font-family: PingFangSC-Semibold, PingFang SC;
    .flex-center{
      display flex;
      align-items center;
    }
    .menusArt{
      width 1200px;
      height 400px;
      margin: 0 auto;
      .mainStyle{
         background-color :#fff;
         margin-top:20px;
      }
      .rowArtTitle{
        margin:15px 0;
        .fontViewMore{
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 17px;
          text-align :right;
          padding-top: 3px;
        }
        .fontArt{
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #0F0F0F;
          line-height: 20px;
        }
     
      }
      .answerQuestion{
        width 100%;
        margin-top 20px;
        .answerContent{
          width 100%;
          margin 0 auto;
          display flex;
          margin-bottom 1px;
        }
      }
      .jifen{
        background-color:#fff;
        border-bottom:1px solid #EDEEEF;
        font-family: PingFangSC-Regular, PingFang SC;

        .jifenGet{
          font-size:18px;
          color:#050505;
          line-height :60px;
          margin-left :24px;
        }

        .getMore{
          margin-left :10px;
          margin-top :2px;
          color :#999;
          font-size :12px;
          line-height :60px;
          font-weight : 200;
          cursor pointer;
        }
      }

      .jfCont{
        background-color:#fff;
        // height :240px;
        text-align:center;
        // padding-top :20px;

        .jfFont{
          font-size :14px;
          color: #050505;
        }
      }
      .articles{
        margin-top 21px;
          .articleContent{
            width 940px;
            margin 0 auto;
            display flex;
            justify-content space-between;
          }
      }
      .articleContainer{
        
        display :flex;
        align-items :center;
        .info{
          width:100%;
          .articleName{
            font-size: 14px;
            font-weight: 400;
            color: #969798;
            text-align:left;
            width :186px;
            line-height :40px;
            span{
             padding-left:75px;
            }
        }
        .borderStyle{
            border-bottom:1px solid #EDEEEF;
            span{
                line-height:20px; 
                border-left:2px solid #F82B17;
                display:inline-block;
                color :#F82B17;
                margin-left: 0px;
                
            }
        }
    }
}
    }

  }
   
</style>